/* byKapwa Redesign 2026-09-15 — Galerie-Pfeile (Desktop), Quick add im Warenkorb (Hinweiszeile ohne Countdown). */
(function () {
  'use strict';

  /* ---------- 11 · Pfeile am Hauptbild: blättern über die Thumbnails ---------- */
  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function galleryStep(wrapper, step) {
    var lists = wrapper.querySelectorAll('.thumbnail__horizoltal, .product-slideshow__thumbnail');
    var thumbs = [];
    for (var i = 0; i < lists.length; i++) {
      if (visible(lists[i])) { thumbs = Array.prototype.slice.call(lists[i].querySelectorAll('.js-slideshow-btn-thumb')); if (thumbs.length) break; }
    }
    if (!thumbs.length) thumbs = Array.prototype.slice.call(wrapper.querySelectorAll('.js-slideshow-btn-thumb'));
    if (!thumbs.length) return;
    var current = -1;
    for (var j = 0; j < thumbs.length; j++) {
      var item = thumbs[j].closest('.product-slideshow__thumb');
      if (item && item.classList.contains('is-active-item')) { current = j; break; }
    }
    if (current < 0) {
      var slides = wrapper.querySelectorAll('.js-product-slideshow-item');
      for (var k = 0; k < slides.length; k++) {
        if (visible(slides[k])) {
          var id = slides[k].getAttribute('data-media-id');
          for (var m = 0; m < thumbs.length; m++) { if (thumbs[m].getAttribute('data-target') === id) { current = m; break; } }
          break;
        }
      }
    }
    if (current < 0) current = 0;
    var next = (current + step + thumbs.length) % thumbs.length;
    thumbs[next].click();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rd-gallery-arrow');
    if (!btn) return;
    e.preventDefault();
    var wrapper = btn.closest('.product__media-wrapper');
    if (wrapper) galleryStep(wrapper, btn.classList.contains('rd-gallery-arrow--next') ? 1 : -1);
  });

  /* ---------- 13 · Produktbeschreibung in Drop-downs aufteilen ---------- */
  var MARKERS = [
    { re: /^details$/i, title: 'Details' },
    { re: /^why you.?ll love it$/i, title: 'Why you’ll love it' },
    { re: /^(size chart|size guide|sizing)$/i, title: 'Size chart' },
    { re: /^(care|fabric care|care instructions)$/i, title: 'Care' },
    { re: /^(shipping|shipping & returns|delivery)$/i, title: 'Shipping & returns' }
  ];
  function markerFor(el) {
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t || t.length > 40) return null;
    for (var i = 0; i < MARKERS.length; i++) if (MARKERS[i].re.test(t)) return MARKERS[i].title;
    return null;
  }
  function isMarkerNode(node) {
    if (node.nodeType !== 1) return null;
    var strong = node.matches('strong,b,h2,h3,h4') ? node : (node.children.length === 1 ? node.querySelector(':scope > strong, :scope > b') : null);
    if (!strong) return null;
    var own = (node.textContent || '').replace(/\s+/g, ' ').trim();
    var inner = (strong.textContent || '').replace(/\s+/g, ' ').trim();
    if (own !== inner) return null;
    return markerFor(strong);
  }
  function buildAccordion(rte) {
    var nodes = Array.prototype.slice.call(rte.childNodes);
    var groups = [{ title: 'Description', nodes: [] }];
    // verschachtelte Wrapper (div > div > p) flach ziehen
    var flat = [];
    (function walk(list) {
      list.forEach(function (n) {
        if (n.nodeType === 1 && n.tagName === 'DIV' && !n.getAttribute('style') && n.querySelector('strong,b,ul,table,p')) {
          walk(Array.prototype.slice.call(n.childNodes));
        } else if (!(n.nodeType === 3 && !n.textContent.trim())) {
          flat.push(n);
        }
      });
    })(nodes);
    flat.forEach(function (n) {
      var m = isMarkerNode(n);
      if (m) { groups.push({ title: m, nodes: [] }); return; }
      if (n.nodeType === 1 && n.tagName === 'DIV' && !n.textContent.trim() && !n.querySelector('img,table')) return;
      groups[groups.length - 1].nodes.push(n);
    });
    if (groups.length < 2) return;
    var frag = document.createDocumentFragment();
    groups.forEach(function (g, i) {
      if (!g.nodes.length) return;
      var d = document.createElement('details');
      d.className = 'rd-acc';
      if (i === 0) d.open = true;
      var s = document.createElement('summary');
      s.textContent = g.title;
      var body = document.createElement('div');
      body.className = 'rd-acc__body rte';
      g.nodes.forEach(function (n) { body.appendChild(n); });
      d.appendChild(s); d.appendChild(body); frag.appendChild(d);
    });
    rte.innerHTML = '';
    rte.appendChild(frag);
    rte.classList.add('rd-acc-wrap');
  }
  function initAccordions() {
    document.querySelectorAll('.product__description > .rte:not(.rd-acc-wrap)').forEach(buildAccordion);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAccordions); else initAccordions();

  /* ---------- 24 · Quick add im Warenkorb-Drawer ---------- */
  function refreshCartDrawer() {
    var root = (window.routes && window.routes.root_url) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.js-cart-drawer-wrapper');
        var live = document.querySelector('#shtCartDrawer .js-cart-drawer-wrapper');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('.js-cart-count-number').forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('.js-cart-drawer-wrapper').forEach(function (el) { el.classList.toggle('is-empty', cart.item_count === 0); });
      })
      .catch(function (err) { console.warn('redesign: cart refresh failed', err); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rd-upsell__btn[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
    btn.classList.add('is-loading');
    var body = { items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] };
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'add failed');
        var item = btn.closest('.rd-upsell__item');
        if (item) { item.querySelectorAll('.rd-upsell__btn').forEach(function (b) { b.classList.add('is-added'); b.textContent = '✓'; }); }
        return refreshCartDrawer();
      })
      .catch(function (err) { console.warn('redesign: quick add failed', err); btn.textContent = '!'; })
      .then(function () { btn.classList.remove('is-loading'); });
  });

  /* ---------- 22 · Countdown entfernt 16.09.2026 – Hinweiszeile steht fest im Drawer ---------- */
})();
